import { computed } from "vue";
import { themeTypes } from "@/src/constants/themeConstants.js";

export const useBaseChartOptions = (effectiveTheme, baseColors) => {
  const isDark = computed(() => effectiveTheme.value === themeTypes.DARK);
  const textColor = "var(--secondary-color)";
  const gridColor = "var(--white-opacity-8)";
  const labelColor = "var(--primary-color)";

  const baseOptions = computed(() => ({
    chart: {
      toolbar: { show: false },
      background: "transparent",
    },
    colors: baseColors,
    grid: {
      show: true,
      borderColor: gridColor,
    },
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "left",
      fontSize: "12px",
      fontFamily: "Proxima Nova, sans-serif",
      fontWeight: 400,
      labels: {
        colors: textColor,
        useSeriesColors: false,
      },
      markers: {
        size: 5,
        shape: "circle",
        strokeWidth: 0,
        offsetX: -4,
      },
      itemMargin: {
        horizontal: 10,
        vertical: 0,
      },
      onItemClick: {
        toggleDataSeries: true,
      },
      onItemHover: {
        highlightDataSeries: true,
      },
      offsetX: -16,
      offsetY: 4,
    },
    tooltip: {
      theme: isDark.value ? "dark" : "light",
    },
  }));

  return {
    baseOptions,
    isDark,
    textColor,
    gridColor,
    labelColor,
  };
};

